import { useGenericModal } from "../../../common/GenericModal";
import { createTimeoutWorker } from "./create-timeout-worker";

export function useTimeoutWarningModals() {
  const expiredModal = useGenericModal();
  const warningModal = useGenericModal();

  const fireWarningModal = (worker: ReturnType<typeof createTimeoutWorker>) => {
    const onConfirm = () => {
      worker?.stop();
      worker?.resume();
      warningModal.set({ isOpen: false });
    };

    warningModal.set({
      isOpen: true,
      title: "Timeout",
      confirmButtonText: `Continue`,
      description: `Your cart is about to expire! Click ‘Continue’ to extend your session by 10 minutes.`,
      isCloseButtonHidden: true,
      onClickConfirm: onConfirm,
      closeIconProps: { onClick: onConfirm },
    });
  };

  const fireExpiredModal = () => {
    expiredModal.set({
      isOpen: true,
      title: "Timeout",
      confirmButtonText: `Continue`,
      description: `Your cart has expired. Click ‘Continue’ to start a new one.`,
      isCloseButtonHidden: true,
      onClickConfirm: () => expiredModal.set({ isOpen: false }),
      closeIconProps: {
        onClick: () => expiredModal.set({ isOpen: false }),
      },
    });
  };

  return { fireWarningModal, fireExpiredModal };
}
